// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5l-0";
export var startPickingButton = "_5l-1";